import Swiper from "../swiper/Swiper";
import Nav from "../nav/Nav";
import "./Home.css";
import Service from "../service/Service";
import Fundas from "../fundas/Fundas";
import Contact from "../contact/Contact";
import Footer from "../footer/Footer";
import ReviewsSlider from "../reviewSlider/ReviewSlider";
import BtnWhatsapp from "../btnWhatsapp/BtnWhatsapp";

const Home = () => {
  return (
    <div className="home">
      <BtnWhatsapp />
      <Nav />
      <Swiper />
      <Service />
      <Fundas />
      <ReviewsSlider />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
